// extracted by mini-css-extract-plugin
export default {"modalError":"styles_modalError__reb1F","closeButton":"styles_closeButton__ed8OX"};